import React from "react"

//Stylesheets
import "../../../styles/components/pages/home/participating-cities.scss"

export default () => (
  <section className="participating-cities">
    <div className="content">
      <div className="city">
        S<span className="mobile-hide">AN&nbsp;</span>F<span className="mobile-hide">RANCISO&nbsp;</span>
      </div>
      <div className="city">
        SEA<span className="mobile-hide">TTLE&nbsp;</span>
      </div>
      <div className="city">
        N<span className="mobile-hide">EW&nbsp;</span>Y<span className="mobile-hide">ORK&nbsp;</span>
      </div>
    </div>
  </section>
)